import React, { Fragment } from 'react';
import { Widget } from '@typeform/embed-react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import grayLogo from '../../../assets/images/Logo_Gray.svg';
import './TypeformModal.scss';

const TYPEFORM_HEIGHT = '400px';
const TYPEFORM_WIDTH = '600px';

const confirmationBody = (
  <div className="confirmation-body">
    <img src={grayLogo} alt="Clora Logo" height="40" width="93" />
    <h1 className="confirmation-header">Thanks for sharing your feedback!</h1>
    <div className="confirmation-subtitle">
      Your feedback is important to us and will help us improve your experience.
    </div>
  </div>
);

class TypeformModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showConfirmation: false,
      showModal: true,
    };
  }

  typeformBody() {
    const {
      headerCopy, actionCopy, promptCopy, typeformId, typeformParams,
    } = this.props;

    return (
      <Fragment>
        <div className="typeform-text">
          <h1 className="typeform-header-text">
            {headerCopy}
          </h1>
          <div className="typeform-subtitle-text body-text-1">
            {actionCopy}
          </div>
          <div className="typeform-subtitle-text body-text-1">
            {promptCopy}
          </div>
          <hr className="mt-0 mb-0" />
        </div>
        { typeformId
        && (
        <Widget
          id={typeformId}
          style={{ height: TYPEFORM_HEIGHT, width: TYPEFORM_WIDTH }}
          hidden={typeformParams}
          onSubmit={() => this.setState({ showConfirmation: true })}
        />
        )}
      </Fragment>
    );
  }

  render() {
    const { showConfirmation, showModal } = this.state;

    return (
      <Modal
        show={showModal}
        onHide={() => this.setState({ showModal: false })}
        dialogClassName="typeform-modal"
      >
        <Modal.Header closeButton />
        <Modal.Body
          className={`typeform-modal-body style-guide${showConfirmation ? ' confirmation' : ''}`}
        >
          {showConfirmation ? confirmationBody : this.typeformBody()}
        </Modal.Body>
      </Modal>
    );
  }
}

TypeformModal.propTypes = {
  typeformId: PropTypes.string.isRequired,
  typeformParams: PropTypes.shape({}),
  headerCopy: PropTypes.string.isRequired,
  actionCopy: PropTypes.string.isRequired,
  promptCopy: PropTypes.string.isRequired,
};

TypeformModal.defaultProps = {
  typeformParams: {},
};

export default TypeformModal;
